module.exports = __webpack_public_path__ + "static/media/5.ec3ecb85.jpg";